import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { RoutingFilterItem } from '../../types/RoutingFilterItem';
import { RoutingFilterPermission } from '../../types/RoutingFilterPermission';
import { FilterGroup, GroupedRoutingFilterView } from '../groupedView/GroupedRoutingFilterView';

export type PermissionGroupedRoutingFilterViewProps = Readonly<{
  filters: ReadonlyArray<RoutingFilterItem>;
  isLoading: boolean;
}>;

function groupFiltersByPermission(filters: ReadonlyArray<RoutingFilterItem>): FilterGroup[] {
  const allowed: RoutingFilterItem[] = [];
  const blocked: RoutingFilterItem[] = [];

  for (const filter of filters) {
    if (filter.isBlocked) {
      blocked.push(filter);
    } else {
      allowed.push(filter);
    }
  }

  const groups: FilterGroup[] = [
    { key: 'allow', label: Messages.bridgeSiteSettingsRoutingFilterPermissionAllow(), filters: allowed, preFill: { permission: RoutingFilterPermission.ALLOW } },
    { key: 'block', label: Messages.bridgeSiteSettingsRoutingFilterPermissionBlock(), filters: blocked, preFill: { permission: RoutingFilterPermission.BLOCK } },
  ];
  return groups;
}

export function PermissionGroupedRoutingFilterView(props: PermissionGroupedRoutingFilterViewProps) {
  const { filters, isLoading } = props;

  const groups = React.useMemo(() => groupFiltersByPermission(filters), [filters]);

  return (
    <GroupedRoutingFilterView
      groupHeaderLabel={Messages.bridgeSiteSettingsRoutingFilterPermissionType()}
      countHeaderLabel={Messages.bridgeSiteSettingsRoutingFiltersColumn()}
      groups={groups}
      isLoading={isLoading}
      testIdPrefix={'permission-routing-filters'}
    />
  );
}
